import React from 'react'
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
import { QueryAppraisalStatus } from '@core/entities/SiteBoxDocumentConfig'

type AppraisalStatusIconProps = {
  userResponse: QueryAppraisalStatus | null | undefined
  fontSize?: 'small' | 'medium' | 'large' | 'inherit'
}

const statusConfig = {
  PASS: { icon: DoneOutlinedIcon, color: 'success' },
  FAIL: { icon: CloseOutlinedIcon, color: 'error' },
  NA: { icon: PriorityHighIcon, color: 'warning' },
} as const

export const AppraisalStatusIcon: React.FC<AppraisalStatusIconProps> = ({
  userResponse,
  fontSize = 'small',
}) => {
  if (!userResponse || userResponse === 'IN_REVIEW') {
    return <PriorityHighIcon fontSize={fontSize} color='disabled' />
  }

  const config = statusConfig[userResponse]
  const IconComponent = config.icon

  return <IconComponent fontSize={fontSize} color={config.color} />
}
